export const CHANGE_STATE = 'CHANGE_STATE'
export const SETUP_QCAA = 'SETUP_QCAA'